﻿import { useEffect } from 'react';

import { SKUDetailsContext, SKUManagementContext } from 'pages/sku_management/context';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { SKUManagementPermissions } from 'pages/sku_management/types';
import { SKUManagement } from 'pages/sku_management/SKUManagement';
import { NotificationContextProvider } from 'app/notifications';
import { TabsContextProvider } from 'components/Tabs/Tabs';
import { SKUDetail } from 'pages/sku_management/SKUDetail';
import { DefaultLayout } from 'components/layout';
import { } from 'pages/access_codes/context';
import { useParams } from 'react-router-dom';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

export type SKUManagementContextValue = {
    permissions: SKUManagementPermissions;
}

export const SKUManagementWrapper = () => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        loading: true,
        permissions: null as unknown as SKUManagementPermissions
    });

    const { loading, permissions } = state;

    const { id } = useParams();

    const fetchPermissions = async () => {

        try {

            const [permissions] = await Promise.all([
                PermissionsApi.Get('SKUManagement')
            ]);

            setState({
                loading: false,
                permissions
            });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    const context: SKUManagementContextValue = {
        permissions
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'sku_management.6a91ee80', defaultMessage: 'SKU Management' })}>
            <SKUManagementContext.Provider value={context}>
                <TabsContextProvider disableUrlSync context={SKUDetailsContext}>
                    <NotificationContextProvider>
                        {loading ?
                            (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                                    <GMetrixLoader />
                                </div>
                            )
                            :
                            (

                                id ? <SKUDetail /> : <SKUManagement />
                            )
                        }
                    </NotificationContextProvider>
                </TabsContextProvider>
            </SKUManagementContext.Provider>
        </DefaultLayout>
    );

};